import React, { Fragment, useEffect, useReducer, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhoneAlt,
  faMapMarkerAlt,
  faDog,
  faInfoCircle,
  faPaw,
  faPen,
  faClock,
  faTimes,
  faCalendarAlt,
  faChevronDown,
  faChevronUp,
  faCrosshairs,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dialog, Switch, Transition } from "@headlessui/react";
import {
  Autocomplete,
  GoogleMap,
  Marker,
  useLoadScript,
  DirectionsRenderer,
  OverlayView,
} from "@react-google-maps/api";
import { CURRENCY_CODE, GoogleMapStyle } from "../../../config/constants";
import ReactPhoneInput from "react-phone-input-2"; // Import the phone input component
import "react-phone-input-2/lib/style.css";
import { PetSelection } from "../../../components/delivery/PetSelection";
import { PromoCodeInput } from "../../../components/PromoCodeInput";
import { StepWizard } from "../../../components/StepWizard";
import { motion } from "framer-motion";
import { usePromoCode } from "../../../hooks/usePromoCode";
import {
  DropoffLocationIcon,
  PartnerLocationIcon,
  PickupLocationIcon,
} from "../../../config/googlemapstyle";
import { convertToAmPm, routes } from "../../../config/utility";
import { deliveryReducer, initialState } from "../../../reducers/deliveryReducer";
import Schedule from "../../Pet Owner/partials/Schedule";
// import LoadingLogo from "../../../components/Loading";
import DeliveryPaymentMethodSelection from "../../Pet Owner/partials/DeliveryPaymentMethod";
import { format, } from 'date-fns';

import api from "../../../api/api";



const libraries = ["places"]; // IMP

const steps = [
  { number: 1, label: "Pickup Location" },
  { number: 2, label: "Dropoff Location" },
  { number: 3, label: "Pets Selection" },
  { number: 4, label: "Details & Coupons" },
  { number: 5, label: "Schedule Delivery" },
  { number: 6, label: "Summary & Submit" },
  { number: 7, label: "Payment Method" },
];

export const DeliveryRequest = ({ item, onSave, onCancel, pets, partnersData, permission, userUpdateContext }) => {
  const DELIVERY_PERICE_PER_KM = parseFloat(permission.PAW_TAXI_PRICE_PER_KM);
  const DELIVERY_BASE_RATE = parseFloat(permission.PAW_TAXI_BASE_RATE);
  const DELIVERY_CAGE_PRICE = parseFloat(permission.PAW_TAXI_CAGE_FEE);
  const applyFreeTaxi = permission.FREE_PAW_TAXI > 0;
  const freeChargeKeys = ["location", "two_way"];

  const [loading, setLoading] = useState(false);
  const [fetchingLocation, setFetchingLocation] = useState(false);
  const [showMainReorderInfo, setShowMainReorderInfo] = useState(true);

  const [step, setStep] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedPartner, setSelectedPartner] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [currentPosition, setCurrentPosition] = useState({
    lat: null,
    lng: null,
  });
  const [deliveryData, setDeliveryData] = useState({});

  const [autocompletePickup, setAutocompletePickup] = useState(null);
  const [autocompleteDropoff, setAutocompleteDropoff] = useState(null);

  const [charges, setCharges] = useState({
    base_rate: DELIVERY_BASE_RATE,
    location: 0,
    want_cage: 0,
    pet: 0,
    two_way: 0,
  });

  const [state, dispatch] = useReducer(deliveryReducer, initialState);

  const getServiceLabel = (key) => {
    switch (key) {
      case "location":
        return "Distance Fee";
      case "pet":
        return "Additional Pet Fee";
      case "want_cage":
        return "Pet Cage Fee";
      case "two_way":
        return "Two-Way Trip Fee";
      default:
        return key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
    }
  };

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries, // Load necessary libraries
  });

  const {
    discount,
    discountAmount,
    promoError,
    promoSuccess,
    applyPromoCode,
    calculateDiscount,
    calculateSpecicalDiscount
  } = usePromoCode(charges, CURRENCY_CODE);

  const vatRate = 0.05; // 5% VAT
  const effectiveBaseRate = state.two_way ? DELIVERY_BASE_RATE * 2 : DELIVERY_BASE_RATE;
  const subTotal = applyFreeTaxi ? total - discountAmount : total + effectiveBaseRate - discountAmount;
  const vatAmount = subTotal * vatRate;
  const finalTotal = subTotal + vatAmount;


  useEffect(() => {
    if (!item) {
      const timeoutId = setTimeout(() => {
        // Only proceed if Google Maps API is loaded
        if (!isLoaded || !window.google?.maps) {
          return;
        }

        // Only get current position for map centering — don't auto-fill pickup/dropoff
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setCurrentPosition({ lat: latitude, lng: longitude });
          },
          (error) => {
            // Error getting current location
          }
        );

        dispatch({
          type: "LOAD_ITEM", payload: {
            partners: partnersData,
          }
        });
      }, 1000);
      return () => clearTimeout(timeoutId);

    } else {
      const timeoutId = setTimeout(() => {
        dispatch({
          type: "LOAD_ITEM", payload: {
            partners: partnersData,
          }
        });
      }, 1000);
      return () => clearTimeout(timeoutId);
    }

  }, [isLoaded]);

  useEffect(() => {
    if (item) {
      const pickup_latitude = item.pickup_latitude || currentPosition.lat || 24.8607;
      const pickup_longitude = item.pickup_longitude || currentPosition.lng || 67.0011;
      const dropoff_latitude = item.dropoff_latitude || pickup_latitude;
      const dropoff_longitude = item.dropoff_longitude || pickup_longitude;

      // Check if this is a reorder (item already has the correct structure)
      if (item.isReorder) {
        dispatch({
          type: "LOAD_ITEM", payload: {
            ...item,
            pickup_latitude,
            pickup_longitude,
            dropoff_latitude,
            dropoff_longitude,
            // pet_ids is already in the correct format for reorder
          }
        });
      } else {
        // Original edit logic for existing deliveries
        dispatch({
          type: "LOAD_ITEM", payload: {
            ...item,
            pickup_latitude,
            pickup_longitude,
            dropoff_latitude,
            dropoff_longitude,
            pet_ids: item.pets ? item.pets.map((pet) => pet.id) : [],
            scheduled_time: item.scheduled_at ? new Date(item.scheduled_at) : null,
          }
        });
      }
    }
  }, [item, currentPosition]);


  // When both pickup and dropoff locations are set, calculate route and distance
  useEffect(() => {
    if (!state.pickup_latitude || !state.dropoff_latitude || !isLoaded || !window.google?.maps) {
      setDirectionsResponse(null); // Clear old path if a location is missing
      return;
    }
    setDirectionsResponse(null); // Clear old path before recalculating
    calculateRoute();
    calculateDistanceAndTime();
  }, [state.pickup_latitude, state.pickup_longitude, state.dropoff_latitude, state.dropoff_longitude, isLoaded]);

  // Calculate directions between pickup and dropoff
  const calculateRoute = () => {
    if (
      !state.pickup_latitude ||
      !state.pickup_longitude ||
      !state.dropoff_latitude ||
      !state.dropoff_longitude ||
      !window.google?.maps
    ) {
      return;
    }
    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin: { lat: state.pickup_latitude, lng: state.pickup_longitude },
        destination: { lat: state.dropoff_latitude, lng: state.dropoff_longitude },
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirectionsResponse(result);
        } else {
          // Error fetching directions
        }
      }
    );
  };


  // useEffect(() => {
  //   if (discount) {
  //     calculateDiscount(discount); // call only if discount is defined
  //   }
  //   const total = Object.entries(charges)
  //     .filter(([key]) => key !== "base_rate")
  //     .reduce((acc, [, value]) => acc + parseFloat(value), 0);

  //   setTotal(total);
  // }, [charges]);

  useEffect(() => {
    const calcTotal = applyFreeTaxi
      ? Object.entries(charges)
        .filter(([key, chargeValue]) => chargeValue > 0 && key !== "base_rate" && !freeChargeKeys.includes(key))
        .reduce((total, entry) => total + Number(entry[1]), 0)
      : Object.entries(charges)
        .filter(([key]) => key !== "base_rate")
        .reduce((acc, [, value]) => acc + parseFloat(value), 0);
    setTotal(calcTotal);
    if (discount) {
      applyFreeTaxi
        ? calculateSpecicalDiscount(discount, charges["location"])
        : calculateDiscount(discount);
    }
  }, [charges, discount, applyFreeTaxi, calculateDiscount, calculateSpecicalDiscount]);

  const handlePlaceSelect = (place, type) => {
    if (!place.geometry) return;
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    const address = place.formatted_address;
    if (type === "pickup") {
      // dispatch({ type: "UPDATE_FIELD", field: "pickup_latitude", payload: lat });
      // dispatch({ type: "UPDATE_FIELD", field: "pickup_longitude", payload: lng });
      // dispatch({ type: "UPDATE_FIELD", field: "pickup_address", payload: address });
      dispatch({
        type: "LOAD_ITEM", payload: {
          pickup_latitude: lat,
          pickup_longitude: lng,
          pickup_address: address,
        }
      });
    } else if (type === "dropoff") {
      // dispatch({ type: "UPDATE_FIELD", field: "dropoff_latitude", payload: lat });
      // dispatch({ type: "UPDATE_FIELD", field: "dropoff_longitude", payload: lng });
      // dispatch({ type: "UPDATE_FIELD", field: "dropoff_address", payload: address });
      dispatch({
        type: "LOAD_ITEM", payload: {
          dropoff_latitude: lat,
          dropoff_longitude: lng,
          dropoff_address: address,
        }
      });
    }
  };

  // Handle dragging of the pickup marker
  const handlePickupDragEnd = (event) => {
    if (!window.google?.maps) return;

    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[1]) {
        const address = results[1].formatted_address;
        dispatch({ type: "UPDATE_FIELD", field: "pickup_address", payload: address });
      }
    });
    // dispatch({ type: "UPDATE_FIELD", field: "pickup_latitude", payload: lat });
    // dispatch({ type: "UPDATE_FIELD", field: "pickup_longitude", payload: lng });
    dispatch({
      type: "LOAD_ITEM", payload: {
        pickup_latitude: lat,
        pickup_longitude: lng,
      }
    });
  };
  // Handle dragging of the dropoff marker
  const handleDropoffDragEnd = (event) => {
    if (!window.google?.maps) return;

    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[1]) {
        const address = results[1].formatted_address;
        dispatch({ type: "UPDATE_FIELD", field: "dropoff_address", payload: address });
      }
    });
    // dispatch({ type: "UPDATE_FIELD", field: "dropoff_latitude", payload: lat });
    // dispatch({ type: "UPDATE_FIELD", field: "dropoff_longitude", payload: lng });
    dispatch({
      type: "LOAD_ITEM", payload: {
        dropoff_latitude: lat,
        dropoff_longitude: lng,
      }
    });
  };

  const validateStep = () => {
    switch (step) {
      case 1:
        if (
          !state.pickup_address &&
          !state.pickup_latitude &&
          !state.pickup_longitude
        ) {
          toast.error("Pickup location is required");
          return false;
        }
        break;
      case 2:
        if (
          !state.dropoff_address &&
          !state.dropoff_latitude &&
          !state.dropoff_longitude
        ) {
          toast.error("Dropoff location is required");
          return false;
        }
        break;
      case 3:
        if (state.pet_ids.length === 0) {
          toast.error("Please select at least one pet");
          return false;
        }
        break;
      case 4:
        if (!state.emergency_no) {
          toast.error("Please provide an emergency contact");
          return false;
        }
        break;
      case 5:
        if (state.scheduleType == 'slot') {
          if (!state.day) {
            toast.error("Please select a day");
            return false;
          }
          if (!state.taxiSlot) {
            toast.error("Please select a slot");
            return false;
          }
        }

        if (state.scheduleType == 'datetime') {
          if (!state.scheduled_at) {
            toast.error("Please select a date time.");
            return false;
          }
        }
        return true;

        break;
      case 6:
        if (!validateAllFields()) {
          toast.error("Please fill out all required fields before submission");
          return false;
        }
        break;
      default:
        return true;
    }
    return true;
  };

  const validateAllFields = () => {
    return (
      state.pickup_address &&
      state.pickup_latitude &&
      state.pickup_longitude &&
      state.dropoff_address &&
      state.dropoff_latitude &&
      state.dropoff_longitude &&
      state.want_cage &&
      state.emergency_no &&
      state.pet_ids.length > 0
    );

    // (state.scheduled_at || state.emergency_no) &&
  };

  const handleNextStep = () => {
    if (validateStep()) {
      if (step < steps.length) {
        setStep(step + 1);
      } else {
        // Submit the form
        toast.success("Form submitted successfully!");
      }
    }
  };

  const handlePrevStep = () => setStep(step - 1);

  const calculateFare = (distance) => {
    // Extract the numeric value and the unit using a regular expression
    const regex = /([\d.]+)\s*(km|m)/i;
    const match = distance.match(regex);

    if (match) {
      let distanceValue = parseFloat(match[1]); // Extract the numeric part
      const unit = match[2].toLowerCase(); // Extract the unit ('km' or 'm')

      // Convert distance to kilometers if it's in meters
      if (unit === "m") {
        distanceValue = distanceValue / 1000; // Convert meters to kilometers
      }

      // Now distanceValue is in kilometers, proceed to calculate the fare
      if (!isNaN(distanceValue)) {
        const calculatedFare = distanceValue * DELIVERY_PERICE_PER_KM; // Calculate the new fare

        // Update the fare for location charges
        setCharges((prevData) => ({
          ...prevData,
          location: calculatedFare.toFixed(2),
          two_way: state.two_way ? parseFloat(calculatedFare.toFixed(2)) : 0,
        }));
      }
    } else {
      // Invalid distance format
    }
  };

  // Calculate distance and time via Google Maps DistanceMatrixService
  const calculateDistanceAndTime = () => {
    const { pickup_latitude, pickup_longitude, dropoff_latitude, dropoff_longitude } = state;
    if (pickup_latitude && pickup_longitude && dropoff_latitude && dropoff_longitude && window.google?.maps) {
      const origin = new window.google.maps.LatLng(pickup_latitude, pickup_longitude);
      const destination = new window.google.maps.LatLng(dropoff_latitude, dropoff_longitude);
      const service = new window.google.maps.DistanceMatrixService();
      service.getDistanceMatrix(
        {
          origins: [origin],
          destinations: [destination],
          travelMode: window.google.maps.TravelMode.DRIVING,
        },
        (response, status) => {
          if (status === "OK") {
            const distance = response.rows[0].elements[0].distance.text;
            const duration = response.rows[0].elements[0].duration.text;
            // dispatch({ type: "UPDATE_FIELD", field: "distance", payload: distance });
            // dispatch({ type: "UPDATE_FIELD", field: "duration", payload: duration });
            dispatch({
              type: "LOAD_ITEM", payload: {
                distance: distance,
                duration: duration,
              }
            });
            calculateFare(distance);
          } else {
            // Error calculating distance
          }
        }
      );
    }
  };

  const handleCageToggle = () => {

    dispatch({ type: "UPDATE_FIELD", field: "want_cage", payload: !state.want_cage });


    if (state.want_cage) {
      setCharges((prevData) => ({
        ...prevData,
        want_cage: 0,
      }));
    } else {
      setCharges((prevData) => ({
        ...prevData,
        want_cage: DELIVERY_CAGE_PRICE,
      }));
    }
  };

  const handleUseMyLocation = () => {
    if (!window.google?.maps) {
      toast.error("Google Maps is not loaded yet.");
      return;
    }
    setFetchingLocation(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setCurrentPosition({ lat: latitude, lng: longitude });
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          { location: { lat: latitude, lng: longitude } },
          (results, status) => {
            if (status === "OK" && results[1]) {
              const address = results[1].formatted_address;
              dispatch({
                type: "LOAD_ITEM", payload: {
                  pickup_latitude: latitude,
                  pickup_longitude: longitude,
                  pickup_address: address,
                }
              });
            } else {
              dispatch({
                type: "LOAD_ITEM", payload: {
                  pickup_latitude: latitude,
                  pickup_longitude: longitude,
                  pickup_address: `${latitude.toFixed(6)}, ${longitude.toFixed(6)}`,
                }
              });
            }
            setFetchingLocation(false);
          }
        );
      },
      (error) => {
        toast.error("Unable to get your location. Please allow location access.");
        setFetchingLocation(false);
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requestData = { ...state };
    try {
      setLoading(true)
      // if (item) {
      //   await api.put(`/deliveries/${item.id}`, requestData);
      //   toast.success("Delivery updated successfully");
      // } else {
      const response = await api.post("/deliveries", requestData);
      setDeliveryData(response.data)
      await userUpdateContext();

      if (response.data.charges?.total <= 3) {
        onSave();
      } else {
        setStep(7)
      }
      setLoading(false)
      toast.success("New Taxi request submitted successfully! A driver will be assigned once you have selected a payment method.");
      // }
      // onSave();
    } catch (error) {
      toast.error("Error saving delivery. Please check the form.");
    } finally {
      setLoading(false)
    }
  };

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading Maps...</div>;
  }

  return (
    <Transition appear show={true} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onCancel}>
        <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />
        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Dialog.Panel className="w-full max-w-7xl transform overflow-hidden rounded-2xl bg-purple-50 text-left align-middle shadow-xl transition-all">
              {/* Reorder Indicator */}
              {item?.isReorder && (
                <div className="bg-purple-50 border border-purple-200 rounded-lg p-3 mx-6 mt-4 shadow-sm">
                  <div
                    className="flex items-center justify-between cursor-pointer"
                    onClick={() => setShowMainReorderInfo(!showMainReorderInfo)}
                  >
                    <div className="flex items-center space-x-2">
                      <FontAwesomeIcon icon={faInfoCircle} className="text-purple-600" />
                      <p className="text-purple-800 font-semibold">🔄 Reordering Previous Delivery</p>
                    </div>
                    <FontAwesomeIcon
                      icon={showMainReorderInfo ? faChevronUp : faChevronDown}
                      className="text-purple-600"
                    />
                  </div>

                  {showMainReorderInfo && (
                    <div className="mt-4 pt-4 border-t border-purple-200 space-y-3">
                      <div className="bg-white rounded-lg p-3 border border-purple-100">
                        <h4 className="text-purple-800 font-semibold mb-2 flex items-center text-sm">
                          ✅ Pre-filled Information:
                        </h4>
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-1 text-xs text-purple-700">
                          <div>• Pickup Location</div>
                          <div>• Dropoff Location</div>
                          <div>• Selected Pets</div>
                          <div>• Cage Preference</div>
                          <div>• Two-way Trip</div>
                          <div>• Emergency Contact</div>
                        </div>
                      </div>

                      <div className="bg-purple-100 rounded-lg p-3 border border-purple-300">
                        <h4 className="text-purple-800 font-semibold mb-1 text-sm">
                          ⏰ Schedule Selection Required
                        </h4>
                        <p className="text-purple-700 text-xs">
                          Choose <strong>Instant Delivery</strong> or select a <strong>new date & time</strong>.
                          Previous scheduling cannot be reused.
                        </p>
                      </div>

                      <div className="text-purple-600 text-xs">
                        💡 <strong>Tip:</strong> You can modify any information before submitting.
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* Step Wizard */}
              <div className="flex items-center justify-between ">
                <StepWizard
                  step={step}
                  setStep={setStep}
                  steps={steps}
                />
              </div>

              <div className="mx-6">
                <form onSubmit={handleSubmit}>
                  <div className="relative">
                    {/* Step 1: Pickup Location */}
                    {step === 1 && (
                      <motion.div
                        className="delivery-service"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                      >
                        <div className="sm:absolute sm:-top-16 sm:left-0 sm:right-0 z-10 sm:flex sm:justify-center sm:px-4 ">

                          <div className="w-full sm:w-2/3 lg:w-1/2 bg-bodyMain p-4 rounded-lg shadow-lg backdrop-blur-md">
                            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-4 mb-3 sm:mb-2">
                              <label className="text-base sm:text-lg font-medium text-gray-900">
                                Pickup Location
                              </label>
                              <button
                                onClick={handleNextStep}
                                type="button"
                                className="w-full sm:w-auto bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 sm:p-3 rounded-lg transition-all duration-150 text-sm sm:text-base"
                              >
                                Next
                              </button>
                            </div>

                            <div className="flex items-center gap-2">
                              <div className="flex-1">
                                <Autocomplete
                                  onLoad={(ref) => setAutocompletePickup(ref)}
                                  onPlaceChanged={() => {
                                    const place = autocompletePickup?.getPlace();
                                    handlePlaceSelect(place, "pickup");
                                  }}
                                >
                                  <input
                                    type="text"
                                    placeholder="Search for pickup location"
                                    value={state.pickup_address}
                                    onChange={(e) =>
                                      dispatch({ type: "UPDATE_FIELD", field: "pickup_address", payload: e.target.value })
                                    }
                                    className="block w-full p-2 sm:p-3 text-sm sm:text-base border border-gray-300 rounded-lg shadow-sm 
                                    focus:ring-purple-600 focus:border-purple-600 transition-all duration-150
                                    placeholder:text-sm sm:placeholder:text-base"                              />
                                </Autocomplete>
                              </div>
                              <button
                                type="button"
                                onClick={handleUseMyLocation}
                                disabled={fetchingLocation}
                                title="Use my current location"
                                className={`flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center rounded-lg shadow-sm transition-all duration-150 ${fetchingLocation
                                  ? "bg-purple-400 cursor-not-allowed"
                                  : "bg-purple-600 hover:bg-purple-700 hover:scale-105"
                                  } text-white`}
                              >
                                {fetchingLocation ? (
                                  <svg className="animate-spin h-4 w-4 sm:h-5 sm:w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                  </svg>
                                ) : (
                                  <FontAwesomeIcon icon={faCrosshairs} className="text-sm sm:text-base" />
                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    )}

                    {/* Step 2: Dropoff Location */}
                    {step === 2 && (
                      <motion.div
                        className="delivery-service"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                      >
                        <div className="sm:absolute sm:-top-16 sm:left-0 sm:right-0 z-10 sm:flex sm:justify-center sm:px-4 ">
                          <div className="w-full sm:w-2/3 lg:w-1/2 bg-bodyMain p-4 rounded-lg shadow-lg backdrop-blur-md">
                            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-4 mb-3 sm:mb-2">
                              <label className="text-base sm:text-lg font-medium text-gray-900">
                                Dropoff Location
                              </label>
                              <button
                                onClick={handleNextStep}
                                type="button"
                                className="w-full sm:w-auto bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 sm:p-3 rounded-lg transition-all duration-150 text-sm sm:text-base"
                              >
                                Next
                              </button>
                            </div>

                            <Autocomplete
                              onLoad={(ref) => setAutocompleteDropoff(ref)}
                              onPlaceChanged={() => {
                                const place = autocompleteDropoff?.getPlace();
                                handlePlaceSelect(place, "dropoff");
                              }}
                            >
                              <input
                                type="text"
                                placeholder="Search for dropoff location"
                                value={state.dropoff_address}
                                onChange={(e) =>
                                  dispatch({ type: "UPDATE_FIELD", field: "dropoff_address", payload: e.target.value })
                                }
                                className="block w-full p-2 sm:p-3 text-sm sm:text-base border border-gray-300 rounded-lg shadow-sm 
                                focus:ring-purple-600 focus:border-purple-600 transition-all duration-150
                                placeholder:text-sm sm:placeholder:text-base"                              />
                            </Autocomplete>
                          </div>
                        </div>
                      </motion.div>

                    )}

                    {step === 6 && (
                      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                        Review & Confirm Your Delivery 📝
                      </h2>
                    )}

                    {/* Map visible only for steps 1, 2, and 8 */}
                    <motion.div
                      className="delivery-service"
                      initial={{ opacity: 0, y: 50 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: 0.2 }}
                    >
                      <div
                        className={`mt-4 sm:mt-10  bg-white shadow-lg rounded-lg ${step === 1 || step === 2 || step === 6
                          ? "block"
                          : "hidden"
                          }`}
                      >
                        <GoogleMap
                          center={
                            step === 1 && state.pickup_latitude
                              ? {
                                lat: state.pickup_latitude,
                                lng: state.pickup_longitude,
                              } // Focus on pickup in Step 1
                              : step === 2 && state.dropoff_latitude
                                ? {
                                  lat: state.dropoff_latitude,
                                  lng: state.dropoff_longitude,
                                } // Focus on dropoff in Step 2
                                : {
                                  lat: state.pickup_latitude,
                                  lng: state.dropoff_longitude,
                                } // Default to pickup center
                          }
                          zoom={step === 1 || step === 2 ? 14 : 13}
                          mapContainerStyle={{
                            width: "100%",
                            height: "500px",
                            borderRadius: "12px",
                            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)", // Subtle shadow
                          }}
                          options={{
                            styles: GoogleMapStyle,
                            disableDefaultUI: true, // Hide default controls for a cleaner look
                            zoomControl: true, // Keep zoom controls
                          }}
                          onLoad={(map) => {
                            if (
                              step === 6 &&
                              state.pickup_latitude &&
                              state.dropoff_latitude
                            ) {
                              const bounds =
                                new window.google.maps.LatLngBounds();
                              bounds.extend({
                                lat: state.pickup_latitude,
                                lng: state.pickup_longitude,
                              });
                              bounds.extend({
                                lat: state.dropoff_latitude,
                                lng: state.dropoff_longitude,
                              });
                              map.fitBounds(bounds); // Automatically adjust map bounds to fit both locations
                            }
                          }}
                        >
                          {/* Custom Pickup Marker */}
                          {state.pickup_latitude && (
                            <Marker
                              position={{
                                lat: state.pickup_latitude,
                                lng: state.pickup_longitude,
                              }}
                              draggable={true}
                              onDragEnd={handlePickupDragEnd}
                              icon={{
                                url: PickupLocationIcon,
                                scaledSize: new window.google.maps.Size(56, 76), // Ensure the icon is scaled to the right size
                              }}
                            />
                          )}

                          {/* Custom Dropoff Marker */}
                          {state.dropoff_latitude && (
                            <Marker
                              position={{
                                lat: state.dropoff_latitude,
                                lng: state.dropoff_longitude,
                              }}
                              draggable={true}
                              onDragEnd={handleDropoffDragEnd}
                              icon={{
                                url: DropoffLocationIcon,
                                scaledSize: new window.google.maps.Size(46, 66), // Ensure the icon is scaled to the right size
                              }}
                            />
                          )}

                          {/* Partner Locations Markers */}

                          {state.partners && (
                            <>
                              {state.partners.map((partner) => (
                                <Marker
                                  key={partner.id}
                                  position={{
                                    lat: partner.location.latitude,
                                    lng: partner.location.longitude,
                                  }}
                                  icon={{
                                    url: PartnerLocationIcon,
                                    scaledSize: new window.google.maps.Size(
                                      46,
                                      56
                                    ),
                                  }}
                                  title={partner.name}
                                  onClick={() => setSelectedPartner(partner)}
                                />
                              ))}

                              {selectedPartner && (
                                <OverlayView
                                  position={{
                                    lat: selectedPartner.location.latitude,
                                    lng: selectedPartner.location.longitude,
                                  }}
                                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                >
                                  <div className="relative p-4 rounded-xl shadow-2xl bg-gradient-to-br from-white via-purple-50 to-purple-100 w-72 text-gray-800 border border-purple-200">
                                    {/* Custom close button */}
                                    <button
                                      type="button"
                                      className="absolute top-3 right-3 text-purple-400 hover:text-purple-600 transition-colors duration-200 bg-purple-100 hover:bg-purple-200 rounded-full p-1"
                                      onClick={() => setSelectedPartner(null)}
                                    >
                                      <FontAwesomeIcon icon={faTimes} size="sm" />
                                    </button>

                                    {/* Partner Header with Icon */}
                                    <div className="flex items-center space-x-3 mb-4 pt-2">
                                      <div className="w-10 h-10 bg-purple-600 rounded-full flex items-center justify-center">
                                        <FontAwesomeIcon icon={faPaw} className="text-white text-sm" />
                                      </div>
                                      <div>
                                        <h3 className="text-lg font-bold text-purple-700 leading-tight">
                                          {selectedPartner.name}
                                        </h3>
                                        <p className="text-xs text-purple-500 font-medium">Partner Location</p>
                                      </div>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="space-y-3 mb-4">
                                      {/* Highlighted Set as Drop-Off Button */}
                                      <button
                                        type="button"
                                        className="w-full bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold py-3 px-4 rounded-lg shadow-lg transform transition-all duration-200 hover:scale-105 hover:shadow-xl flex items-center justify-center space-x-2"
                                        onClick={() => {
                                          dispatch({
                                            type: "LOAD_ITEM", payload: {
                                              dropoff_latitude: selectedPartner.location.latitude,
                                              dropoff_longitude: selectedPartner.location.longitude,
                                              dropoff_address: selectedPartner.location.address,
                                            }
                                          });
                                          setSelectedPartner(null);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="text-white" />
                                        <span>Set as Drop-Off Location</span>
                                      </button>

                                      {/* Visit Website Button */}
                                      {selectedPartner.website && (
                                        <button
                                          type="button"
                                          className="w-full bg-white hover:bg-purple-50 text-purple-600 hover:text-purple-700 font-semibold py-2 px-4 rounded-lg border-2 border-purple-200 hover:border-purple-300 transition-all duration-200 flex items-center justify-center space-x-2"
                                          onClick={() =>
                                            window.open(
                                              selectedPartner.website,
                                              "_blank"
                                            )
                                          }
                                        >
                                          <FontAwesomeIcon icon={faInfoCircle} className="text-purple-500" />
                                          <span>Visit Website</span>
                                        </button>
                                      )}
                                    </div>

                                    {/* Partner Name */}
                                    <h3 className="text-lg font-bold text-purple-700 mb-2">
                                      {selectedPartner.name}
                                    </h3>

                                    {/* Pet Service Type */}
                                    {selectedPartner.serviceType && (
                                      <p className="text-sm text-gray-700 mb-2">
                                        <strong className="font-semibold">
                                          Service:
                                        </strong>{" "}
                                        {selectedPartner.serviceType}
                                      </p>
                                    )}

                                    {/* Address */}
                                    <p className="text-sm text-gray-700 mb-1">
                                      <strong className="font-semibold">
                                        Address:
                                      </strong>{" "}
                                      {selectedPartner.location.address ||
                                        "Not available"}
                                    </p>

                                    {/* Contact (if available) */}
                                    {selectedPartner.contact && (
                                      <p className="text-sm text-gray-700 mb-1">
                                        <strong className="font-semibold">
                                          Contact:
                                        </strong>{" "}
                                        {selectedPartner.contact}
                                      </p>
                                    )}

                                    {/* Description (if available) */}
                                    {selectedPartner.description && (
                                      <p className="text-sm text-gray-600 italic mb-2">
                                        {selectedPartner.description}
                                      </p>
                                    )}

                                    {/* Operating Hours */}
                                    {selectedPartner.hours && (
                                      <div className="mt-2">
                                        <p className="text-sm font-semibold text-gray-700 mb-1">
                                          Operating Hours:
                                        </p>
                                        <div className="text-sm text-gray-600">
                                          {Object.entries(
                                            selectedPartner.hours
                                          ).map(([day, hours]) => (
                                            <p
                                              key={day}
                                              className="flex justify-between"
                                            >
                                              <span>{day}:</span>
                                              <span>
                                                {hours.open
                                                  ? `${hours.start} - ${hours.end}`
                                                  : "Closed"}
                                              </span>
                                            </p>
                                          ))}
                                        </div>
                                      </div>
                                    )}


                                  </div>
                                </OverlayView>
                              )}
                            </>
                          )}

                          {/* DirectionsRenderer for the route */}
                          {state.pickup_latitude &&
                            state.dropoff_latitude &&
                            directionsResponse && (
                              <DirectionsRenderer
                                directions={directionsResponse}
                                options={{
                                  suppressMarkers: true, // Use custom markers instead of default ones
                                  polylineOptions: {
                                    strokeColor: "#9A48FF", // Use your theme's purple
                                    strokeOpacity: 1,
                                    strokeWeight: 6,
                                  },
                                }}
                              />
                            )}
                        </GoogleMap>
                      </div>
                    </motion.div>

                  </div>

                  {step < 3 && (
                    <motion.div
                      className="delivery-service"
                      initial={{ opacity: 0, y: -50 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: 0.3 }}
                    >
                      <div className="flex items-start bg-gradient-to-r from-purple-100 to-purple-100 border border-purple-200 p-5 rounded-lg shadow-md space-x-4 mt-8">
                        {/* Main Icon */}
                        <div className="text-purple-600 flex items-center justify-center w-12 h-12 bg-purple-200 rounded-full">
                          <FontAwesomeIcon icon={faPaw} size="lg" />
                        </div>

                        {/* Text Content */}
                        <div className="flex-1 text-gray-800">
                          {/* Title */}
                          <h4 className="font-bold text-xl text-purple-700 mb-1">
                            Explore Our Trusted Partners
                          </h4>

                          {/* Subtitle */}
                          <p className="text-sm text-gray-700 mb-3">
                            Look out for partner icons on the map for convenient
                            drop-off spots. Click on any partner icon to view more
                            details about their pet services. You can also set a
                            partner location as your drop-off point for added
                            convenience!.
                          </p>

                          {/* Highlighted Partner Icon Example */}
                          <div className="flex items-center space-x-3 mt-2">
                            <svg
                              width="40"
                              height="42"
                              viewBox="0 0 40 42"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.6973 25.5934C16.9896 23.5526 20.0267 23.5333 22.8136 25.526C24.45 27.4369 26.6016 28.4043 29.2585 28.4332C29.6868 28.438 30.1297 28.4188 30.5821 28.3754C31.3378 28.3177 31.641 28.9049 31.4918 30.1419C31.4581 30.4307 31.3955 30.7532 31.3137 31.1093C30.3751 36.2836 27.3813 39.1426 22.3226 39.6769C22.3611 40.0812 22.4237 40.447 22.5199 40.7791C23.5596 41.3326 24.5271 41.607 25.4223 41.607C26.5101 41.607 27.4872 41.1979 28.3632 40.3748C30.8853 37.6265 32.5988 34.6904 33.4893 31.5618C35.4675 24.6452 33.0368 12.8143 23.1601 17.0596C22.1878 17.6853 21.283 18.0029 20.4358 18.0126C20.2722 18.0126 20.1085 18.0029 19.9497 17.9837C19.7909 18.0029 19.6272 18.0174 19.4636 18.0126C18.6164 18.0078 17.7067 17.6901 16.7393 17.0596C6.85291 12.8143 4.42705 24.6452 6.40047 31.5618C7.29573 34.6904 9.00442 37.6265 11.5265 40.3748C12.3977 41.193 13.3796 41.607 14.4674 41.607C15.5648 41.607 16.7682 41.1931 18.087 40.3604L18.1014 40.3507C18.4817 40.1967 18.8571 40.0908 19.2373 40.0331C19.3577 39.7683 19.4636 39.4892 19.5598 39.1956C20.1133 36.8997 19.7331 35.0947 18.4143 33.7807C16.8067 32.5629 15.8729 31.2441 15.6178 29.8338C15.459 31.1238 15.8921 32.3223 16.927 33.4245C19.2614 36.9526 19.0111 39.2822 16.1713 40.4181C12.6143 41.1449 10.4147 39.1522 9.58682 34.4449C9.2162 30.8302 10.588 27.8749 13.6973 25.5934Z"
                                fill="#333271"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M22.4046 28.9628C21.7788 28.9868 21.2927 29.5163 21.3168 30.142C21.3408 30.7677 21.8703 31.2539 22.496 31.2298C23.1217 31.2057 23.6127 30.6763 23.5838 30.0506C23.5549 29.4248 23.0303 28.9387 22.4046 28.9628Z"
                                fill="#333271"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M28.1805 0.444445C30.2213 1.79696 30.5726 5.82081 28.965 9.43554C27.3574 13.0503 24.3973 14.8841 22.3565 13.5364C20.3156 12.1839 19.9643 8.16004 21.5719 4.54531C23.1795 0.930581 26.1396 -0.90807 28.1805 0.444445Z"
                                fill="#333271"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M39.5541 8.31403C40.5793 10.48 39.1786 13.8011 36.4255 15.7264C33.6723 17.6565 30.6111 17.464 29.5859 15.298C28.5607 13.1321 29.9613 9.81094 32.7145 7.88565C35.4676 5.96036 38.5288 6.15289 39.5541 8.31403Z"
                                fill="#333271"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M11.7095 0.747669C9.66868 2.10018 9.31731 6.12404 10.9249 9.73877C12.5325 13.3535 15.4927 15.1873 17.5335 13.8348C19.5743 12.4823 19.9257 8.45845 18.318 4.84372C16.7104 1.22899 13.7503 -0.604846 11.7095 0.747669Z"
                                fill="#333271"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M0.335869 8.61743C-0.689347 10.7834 0.7113 14.1045 3.46446 16.0298C6.21763 17.9647 9.27884 17.7722 10.3041 15.6062C11.3293 13.4403 9.92862 10.1192 7.17546 8.19387C4.4223 6.26377 1.36109 6.45148 0.335869 8.61743Z"
                                fill="#333271"
                              />
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M30.611 28.7895C30.38 28.8136 30.149 28.828 29.9276 28.8377H29.8987C30.0816 29.1842 30.2741 29.4393 30.4859 29.603C30.6736 29.7473 30.8758 29.8099 31.102 29.7955C31.1261 29.4152 31.0924 29.1361 31.0057 28.9628C30.9383 28.8328 30.8084 28.7751 30.611 28.7895Z"
                                fill="#333271"
                              />
                            </svg>
                            <div className="text-sm">
                              <span className="text-gray-700 font-semibold">
                                Partner Location
                              </span>
                              <p className="text-gray-600">
                                Pet-friendly drop-off point
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  )}

                  {/* Additional Details */}
                  {step >= 3 && (
                    <div className="mb-4 p-3">
                      {step === 3 && (
                        <PetSelection
                          state={state}
                          pets={pets}
                          dispatch={dispatch}
                          setCharges={setCharges}
                          permission={permission}
                        />
                      )}

                      {step === 4 && (
                        <>
                          {/* Cage Information */}
                          <motion.div
                            className="delivery-service px-4 sm:px-6"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: 0.2 }}
                          >
                            <p className="text-sm sm:text-base text-gray-600 mb-4">
                              Need a cage to securely transport your dog? Don't worry, we have you covered
                              for a small charge. Select either to have the cage or not.
                            </p>
                          </motion.div>

                          {/* Cage Toggle Switch */}
                          <motion.div
                            className="delivery-service px-4 sm:px-6"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: 0.4 }}
                          >
                            <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-6">
                              <span className="text-base sm:text-lg text-gray-700 font-bold flex items-center">
                                I want a cage:

                              </span>
                              <Switch
                                checked={state.want_cage}
                                onChange={handleCageToggle}
                                className={`${state.want_cage ? "bg-purple-600" : "bg-gray-200"
                                  } relative inline-flex items-center h-6 rounded-full w-11 transition-colors`}
                              >
                                <span
                                  className={`${state.want_cage ? "translate-x-6" : "translate-x-1"
                                    } inline-block w-4 h-4 transform bg-white rounded-full transition-transform`}
                                />
                              </Switch>
                              <p className="text-xs sm:text-sm text-gray-500 mt-1 ml-1 sm:ml-0">
                                <FontAwesomeIcon icon={faInfoCircle} className="mr-1 text-purple-400" />
                                <span>
                                  <strong>Note:</strong> Selecting this option will add an additional cost of <span className="font-semibold text-purple-700">{DELIVERY_CAGE_PRICE.toFixed(2)} {CURRENCY_CODE}</span> to your total.
                                </span>
                              </p>
                            </div>
                          </motion.div>

                          {/* Delivery Option */}
                          <motion.div
                            className="delivery-service px-4 sm:px-6"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: 0.6 }}
                          >
                            <div className="mb-6">
                              <label
                                htmlFor="twoWay"
                                className="block text-base sm:text-lg font-bold text-gray-700 mb-2"
                              >
                                Will you pick your pet or should we deliver back?
                              </label>

                              <select
                                id="twoWay"
                                value={state.two_way}
                                onChange={(e) => {
                                  dispatch({
                                    type: "UPDATE_FIELD",
                                    field: "two_way",
                                    payload: e.target.value === "true"
                                  })

                                  e.target.value === "true"
                                    ? setCharges((prevData) => ({
                                      ...prevData,
                                      two_way: prevData.location,
                                    }))
                                    : setCharges((prevData) => ({
                                      ...prevData,
                                      two_way: 0,
                                    }));
                                }}
                                className="block w-full px-3 sm:px-4 py-2 sm:py-3 bg-white border 
                                border-gray-300 rounded-lg shadow-sm focus:ring-purple-500 
                                focus:border-purple-500 text-sm sm:text-base"
                              >
                                <option value="" disabled>Select an option</option>
                                <option value="false">I'll pick the pet</option>
                                <option value="true">Deliver back to me</option>
                              </select>
                              <p className="text-xs sm:text-sm text-gray-600 mt-2">
                                Note: On delivering back, extra delivery and waiting charges apply.
                              </p>
                            </div>
                          </motion.div>

                          {/* Emergency Contact Section */}
                          <motion.div
                            className="delivery-service px-4 sm:px-6"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: 0.8 }}
                          >
                            <div className="mb-6">
                              <h1 className="text-base sm:text-lg font-bold text-gray-700 mb-2">
                                Emergency Contact{" "}
                                <span role="img" aria-label="emergency">🚨</span>
                              </h1>

                              <div className="relative w-full">
                                <ReactPhoneInput
                                  country={"ae"}
                                  value={state.emergency_no}
                                  onChange={(value) =>
                                    dispatch({ type: "UPDATE_FIELD", field: "emergency_no", payload: value })
                                  }
                                  inputStyle={{
                                    width: "100%",
                                    padding: "12px 12px 12px 50px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    color: "#4b5563",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                                    height: "44px",
                                    '@media (min-width: 640px)': {
                                      padding: "14px 14px 14px 60px",
                                      fontSize: "16px",
                                      height: "50px",
                                    }
                                  }}
                                  buttonStyle={{
                                    border: "none",
                                    background: "transparent",
                                    padding: "0 8px",
                                    borderRadius: "8px 0 0 8px",
                                    height: "44px",
                                    '@media (min-width: 640px)': {
                                      height: "50px",
                                    }
                                  }}
                                  containerClass="mb-2"
                                  inputClass="focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                                  dropdownClass="phone-dropdown"
                                  searchPlaceholder="Search country"
                                  enableSearch={true}
                                  searchStyle={{
                                    padding: "8px 10px",
                                    fontSize: "14px",
                                    border: "1px solid #d1d5db",
                                    borderRadius: "6px",
                                    margin: "4px",
                                  }}
                                  dropdownStyle={{
                                    width: "300px",
                                    maxHeight: "300px",
                                    margin: "4px 0",
                                    padding: "4px",
                                    borderRadius: "8px",
                                  }}
                                />
                              </div>
                            </div>
                          </motion.div>

                          {/* Promo Code Section */}
                          <motion.div
                            className="delivery-service px-4 sm:px-6"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.5, delay: 1.0 }}
                          >
                            <PromoCodeInput
                              state={state}
                              dispatch={dispatch}
                              applyPromoCode={applyPromoCode}
                              promoError={promoError}
                              promoSuccess={promoSuccess}
                              discountAmount={discountAmount}
                            />
                          </motion.div>
                        </>
                      )}

                      {step === 5 && (
                        <Schedule state={state} dispatch={dispatch} />

                      )}
                      {step === 6 && (
                        <>
                          {/* Pickup and Dropoff Section */}
                          <div className="mb-4 sm:mb-6">
                            {/* Header */}
                            <div className="flex items-center justify-between pb-2 sm:pb-4">
                              <h3 className="text-base sm:text-xl text-gray-600 flex items-center">
                                <FontAwesomeIcon
                                  icon={faPaw}
                                  className="text-purple-600 mr-2 w-4 h-4 sm:w-5 sm:h-5"
                                />
                                Locations 🗺️
                              </h3>
                              <button
                                type="button"
                                onClick={() => setStep(1)}
                                className="ml-2 sm:ml-4 text-primary hover:text-accent transition-colors"
                              >
                                <FontAwesomeIcon icon={faPen} className="h-3 w-3 sm:h-4 sm:w-4" />
                              </button>
                            </div>

                            {/* Main Content */}
                            <div className="bg-gray-50 p-3 sm:p-6 rounded-lg space-y-3 sm:space-y-4 
                              shadow-md border-l-4 sm:border-l-8 border-purple-300">

                              {/* Pricing Info */}
                              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center 
                                border-b pb-3 sm:pb-4 border-gray-200">
                                <div className="mb-3 sm:mb-0">
                                  <p className="text-lg sm:text-2xl font-bold text-tblue mb-1 sm:mb-2">
                                    <strong>Important Pricing Info 📢</strong>
                                  </p>
                                  <p className="text-sm sm:text-xl font-bold text-tblue">
                                    <strong>
                                      To ensure you're aware, our service has a base rate that applies:
                                    </strong>
                                  </p>
                                </div>
                                <div className="self-end sm:self-auto">
                                  <p className="text-base sm:text-lg text-gray-800">
                                    <strong>Base Rate:</strong>{" "}
                                    <span className="text-purple-600 font-semibold">
                                      {`${DELIVERY_BASE_RATE} ${CURRENCY_CODE}`}
                                    </span>
                                  </p>
                                </div>
                              </div>

                              {/* Distance and Fare */}
                              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center 
                                          border-b pb-3 sm:pb-4 border-gray-200 space-y-2 sm:space-y-0">
                                <div>
                                  <p className="text-xs sm:text-sm text-gray-700">
                                    <strong>Distance:</strong> {state.distance || "N/A"}
                                  </p>
                                  <p className="text-xs sm:text-sm text-gray-700">
                                    <strong>Estimated Time:</strong> {state.duration || "N/A"}
                                  </p>
                                </div>
                                <div className="w-full sm:w-auto">
                                  <p className="text-xs sm:text-sm text-gray-700">
                                    <strong>Estimated Fare: </strong>
                                    <span className="text-purple-600">
                                      {state.two_way
                                        ? `${charges.location * 2} ${CURRENCY_CODE}`
                                        : `${charges.location} ${CURRENCY_CODE}`}
                                    </span>
                                  </p>
                                  {state.two_way && (
                                    <>
                                      <p className="text-xs sm:text-sm text-gray-500 mt-1">
                                        (Fare is doubled for a two-way trip)
                                      </p>
                                      <span className="inline-block mt-1 px-2 py-1 bg-purple-100 
              text-purple-800 text-xs font-semibold rounded-full">
                                        Two-way trip enabled
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>

                              {/* Pickup Location */}
                              <div className="flex items-start border-b pb-3 sm:pb-4 border-gray-200">
                                <FontAwesomeIcon
                                  icon={faMapMarkerAlt}
                                  className="text-purple-600 w-4 h-4 sm:w-6 sm:h-6 mt-1 sm:mt-0 mr-3 sm:mr-4"
                                />
                                <div className="flex-1">
                                  <p className="text-sm sm:text-base text-gray-800 font-semibold mb-1">
                                    Pickup Location
                                  </p>
                                  <p className="text-xs sm:text-sm text-gray-600 break-words">
                                    {state.pickup_address || "Pickup address not set"}
                                  </p>
                                </div>
                              </div>

                              {/* Dropoff Location */}
                              <div className="flex items-start">
                                <FontAwesomeIcon
                                  icon={faMapMarkerAlt}
                                  className="text-purple-600 w-4 h-4 sm:w-6 sm:h-6 mt-1 sm:mt-0 mr-3 sm:mr-4"
                                />
                                <div className="flex-1">
                                  <p className="text-sm sm:text-base text-gray-800 font-semibold mb-1">
                                    Dropoff Location
                                  </p>
                                  <p className="text-xs sm:text-sm text-gray-600 break-words">
                                    {state.dropoff_address || "Dropoff address not set"}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Pets Section */}
                          <div className="mb-4 sm:mb-6">
                            {/* Header */}
                            <div className="flex justify-between items-center border-b pb-2 sm:pb-4 border-gray-200">
                              <div className="flex items-center justify-between">
                                <h3 className="text-base sm:text-xl text-gray-600 flex items-center">
                                  <FontAwesomeIcon
                                    icon={faPaw}
                                    className="text-purple-600 mr-2 w-4 h-4 sm:w-5 sm:h-5"
                                  />
                                  Selected Pets
                                </h3>
                                <button
                                  type="button"
                                  onClick={() => setStep(3)}
                                  className="ml-2 sm:ml-4 text-primary hover:text-accent transition-colors"
                                >
                                  <FontAwesomeIcon icon={faPen} className="h-3 w-3 sm:h-4 sm:w-4" />
                                </button>
                              </div>
                            </div>

                            {/* Pet Cards Grid */}
                            <div className="mt-3 sm:mt-4 p-2 sm:p-4 rounded-md shadow-sm grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4">
                              {pets
                                .filter((pet) => state.pet_ids.includes(pet.id))
                                .map((pet) => (
                                  <div
                                    key={pet.id}
                                    className="flex items-center space-x-2 sm:space-x-4 bg-white p-2 sm:p-3 rounded-lg shadow hover:shadow-md transition-shadow duration-200"
                                  >
                                    {/* Pet Image */}
                                    <img
                                      src={pet.primary_image_url}
                                      alt={pet.name}
                                      className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover flex-shrink-0"
                                    />
                                    {/* Pet Info */}
                                    <div className="min-w-0 flex-1">
                                      <p className="text-sm sm:text-base text-gray-700 font-semibold truncate">
                                        {pet.name}
                                      </p>
                                      <p className="text-xs sm:text-sm text-gray-500 truncate">
                                        {pet.breed}
                                      </p>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>

                          {/* Details & Coupons Section */}
                          <div className="mb-4 sm:mb-6">
                            {/* Header */}
                            <div className="flex justify-between items-center border-b pb-2 sm:pb-4 border-gray-200">
                              <div className="flex items-center justify-between">
                                <h3 className="text-base sm:text-xl text-gray-600 flex items-center">
                                  <FontAwesomeIcon
                                    icon={faPaw}
                                    className="text-purple-600 mr-2 w-4 h-4 sm:w-5 sm:h-5"
                                  />
                                  Details & Coupons
                                </h3>
                                <button
                                  type="button"
                                  onClick={() => setStep(4)}
                                  className="ml-2 sm:ml-4 text-primary hover:text-accent transition-colors"
                                >
                                  <FontAwesomeIcon icon={faPen} className="h-3 w-3 sm:h-4 sm:w-4" />
                                </button>
                              </div>
                            </div>

                            {/* Content */}
                            <div className="bg-white p-3 sm:p-4 rounded-md space-y-3 sm:space-y-4 
                                    shadow-md border-l-4 sm:border-l-8 border-purple-300">

                              {/* Cage Section */}
                              {state.want_cage && (
                                <div className="flex items-center">
                                  <FontAwesomeIcon
                                    icon={faDog}
                                    className="text-purple-600 w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 flex-shrink-0"
                                  />
                                  <span className="text-sm sm:text-base text-gray-700">
                                    <strong>Include Cage:</strong> Yes
                                  </span>
                                </div>
                              )}

                              {/* Emergency Contact Section */}
                              {state.emergency_no && (
                                <div className="flex items-center">
                                  <FontAwesomeIcon
                                    icon={faPhoneAlt}
                                    className="text-purple-600 w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 flex-shrink-0"
                                  />
                                  <span className="text-sm sm:text-base text-gray-700 break-words">
                                    <strong>Emergency Contact:</strong>{" "}
                                    {state.emergency_no}
                                  </span>
                                </div>
                              )}

                              {/* Additional Info Section */}
                              {state.additionalInfo && (
                                <div className="flex items-start">
                                  <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    className="text-purple-600 w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 mt-0.5 flex-shrink-0"
                                  />
                                  <span className="text-sm sm:text-base text-gray-700 break-words">
                                    <strong>Additional Info:</strong>{" "}
                                    {state.additionalInfo}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Schedule Delivery Section */}

                          {(state.scheduleType == 'slot' || state.scheduleType == 'datetime') && (
                            <div className="mb-4 sm:mb-6">
                              {/* Header */}
                              <div className="flex justify-between items-center border-b pb-2 sm:pb-4 border-gray-200">
                                <h3 className="text-base sm:text-xl text-gray-600 flex items-center">
                                  <FontAwesomeIcon
                                    icon={faPaw}
                                    className="text-purple-600 mr-2 w-4 h-4 sm:w-5 sm:h-5"
                                  />
                                  Schedule
                                </h3>
                                <button
                                  type="button"
                                  onClick={() => setStep(5)}
                                  className="ml-2 sm:ml-4 text-primary hover:text-accent transition-colors"
                                >
                                  <FontAwesomeIcon
                                    icon={faPen}
                                    className="h-3 w-3 sm:h-4 sm:w-4"
                                  />
                                </button>
                              </div>

                              {/* Content */}
                              <div className="bg-white p-3 sm:p-4 rounded-md space-y-3 sm:space-y-4 
      shadow-md border-l-4 sm:border-l-8 border-purple-300">

                                {/* Day Section */}
                                {(state.scheduleType == 'slot' && state.day) && (
                                  <div className="flex items-center">
                                    <FontAwesomeIcon
                                      icon={faCalendarAlt}
                                      className="text-purple-600 w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 flex-shrink-0"
                                    />
                                    <span className="text-sm sm:text-base text-gray-700">
                                      <strong>Day:</strong> {state.day}
                                    </span>
                                  </div>
                                )}

                                {/* Slot Section */}
                                {(state.scheduleType == 'slot' && state.taxiSlot) && (
                                  <div className="flex items-center">
                                    <FontAwesomeIcon
                                      icon={faClock}
                                      className="text-purple-600 w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 flex-shrink-0"
                                    />
                                    <span className="text-sm sm:text-base text-gray-700">
                                      <strong>Slot:</strong> {convertToAmPm(state.taxiSlot)}
                                    </span>
                                  </div>
                                )}

                                {/* DateTime Section */}
                                {(state.scheduleType == 'datetime' && state.scheduled_at) && (
                                  <div className="flex items-center">
                                    <FontAwesomeIcon
                                      icon={faClock}
                                      className="text-purple-600 w-4 h-4 sm:w-5 sm:h-5 mr-2 sm:mr-3 flex-shrink-0"
                                    />
                                    <span className="text-sm sm:text-base text-gray-700 break-words">
                                      <strong>Scheduled Time:</strong>{" "}
                                      {format(new Date(state.scheduled_at), 'PPpp')}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}

                          <div className="my-4 sm:my-6">
                            <label
                              htmlFor="additionalInfo"
                              className="block text-base sm:text-xl text-gray-600 flex items-center mb-2 sm:mb-3"
                            >
                              <FontAwesomeIcon
                                icon={faPaw}
                                className="text-purple-600 mr-2 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0"
                              />
                              Any Additional Information You'd Like To Share
                            </label>
                            <textarea
                              id="additionalInfo"
                              rows="4"
                              value={state.additional_info}
                              onChange={(e) =>
                                dispatch({
                                  type: "UPDATE_FIELD",
                                  field: "additional_info",
                                  payload: e.target.value
                                })
                              }
                              className="block w-full px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base 
      border border-gray-300 rounded-lg shadow-sm 
      focus:ring-purple-500 focus:border-purple-500 
      placeholder:text-gray-400 placeholder:text-sm sm:placeholder:text-base
      resize-none"
                              placeholder="Enter any special instructions or additional details here..."
                            />
                          </div>

                          <div className="mb-6 sm:mb-8">
                            {/* Header */}
                            <h3 className="text-base sm:text-xl text-gray-600 mb-3 sm:mb-4 flex items-center">
                              <FontAwesomeIcon
                                icon={faPaw}
                                className="text-purple-600 mr-2 w-4 h-4 sm:w-5 sm:h-5"
                              />
                              Cost Breakdown
                            </h3>

                            {/* Main Content Container */}
                            <div className="bg-white p-3 sm:p-6 rounded-lg shadow-md border-l-4 sm:border-l-8 border-purple-300">
                              {/* Free Taxi Banner */}
                              {applyFreeTaxi && (
                                <div className="mb-4 sm:mb-6 p-3 sm:p-4 bg-purple-50 border-l-4 border-purple-400 rounded-md flex items-start sm:items-center">
                                  <FontAwesomeIcon
                                    icon={faPaw}
                                    className="text-purple-500 mr-2 sm:mr-3 w-4 h-4 sm:w-5 sm:h-5 mt-1 sm:mt-0 flex-shrink-0"
                                  />
                                  <span className="text-sm sm:text-base text-purple-800 font-semibold">
                                    Congratulations! Your walk is fully covered with your membership.
                                    You'll only be charged for add-ons such as pet cage, or extra pets.🎉
                                  </span>
                                </div>
                              )}

                              {/* Service Charges Section */}
                              <div className="mb-4">
                                <h4 className="text-base sm:text-lg font-semibold text-gray-700 mb-2 sm:mb-3">
                                  Service Charges
                                </h4>
                                <div className="space-y-2 sm:space-y-3">
                                  {Object.keys(charges).map((key, index) => {
                                    const chargeValue = charges[key];
                                    if (key === "base_rate" || chargeValue <= 0) return null;

                                    const isChargeFree = freeChargeKeys.includes(key);
                                    const label = getServiceLabel(key);
                                    const formattedCharge = (Number(chargeValue) || 0).toFixed(2);
                                    return (
                                      <div key={index} className="flex items-center justify-between">
                                        <span className="text-sm sm:text-base text-gray-600 flex items-center">
                                          <FontAwesomeIcon
                                            icon={faPaw}
                                            className="text-yellow-500 mr-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                          />
                                          {label}:
                                        </span>
                                        <div className="inline-flex items-center">
                                          {applyFreeTaxi && isChargeFree ? (
                                            <>
                                              <span className="text-sm sm:text-base text-green-500 font-semibold">FREE </span>
                                              <span className="text-sm sm:text-base text-gray-800 line-through ml-1">
                                                <strong>{formattedCharge} {CURRENCY_CODE}</strong>
                                              </span>
                                            </>
                                          ) : (
                                            <span className="text-sm sm:text-base text-gray-800">
                                              <strong>{formattedCharge} {CURRENCY_CODE}</strong>
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>

                              {/* Service Total */}
                              <div className="flex items-center justify-between border-t pt-3">
                                <span className="text-sm sm:text-base text-gray-600 flex items-center">
                                  <FontAwesomeIcon
                                    icon={faPaw}
                                    className="text-tblue mr-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                  />
                                  Service Total:
                                </span>
                                <span className="text-sm sm:text-base text-gray-800">
                                  <strong>
                                    {total.toFixed(2)} {CURRENCY_CODE}
                                  </strong>
                                </span>
                              </div>

                              {/* Base Rate */}
                              <div className="flex items-center justify-between pt-3">
                                <span className="text-sm sm:text-base text-gray-600 flex items-center">
                                  <FontAwesomeIcon
                                    icon={faPaw}
                                    className="text-tblue mr-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                  />
                                  Base Rate:
                                </span>
                                <div className="inline-flex items-center">
                                  {applyFreeTaxi ? (
                                    <>
                                      <span className="text-sm sm:text-base text-green-500 font-semibold">FREE</span>
                                      <span className="text-sm sm:text-base text-gray-800 line-through ml-1">
                                        <strong>{(state.two_way ? DELIVERY_BASE_RATE * 2 : DELIVERY_BASE_RATE).toFixed(2)} {CURRENCY_CODE}</strong>
                                      </span>
                                    </>
                                  ) : (
                                    <span className="text-sm sm:text-base text-gray-800">
                                      <strong>+{(state.two_way ? DELIVERY_BASE_RATE * 2 : DELIVERY_BASE_RATE).toFixed(2)} {CURRENCY_CODE}</strong>
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* Discount Section */}
                              {discountAmount > 0 && (
                                <>
                                  {!applyFreeTaxi && (
                                    <div className="flex items-center mt-3 justify-between border-t pt-3">
                                      <span className="text-xs sm:text-sm text-gray-600 flex items-center">
                                        <FontAwesomeIcon
                                          icon={faPaw}
                                          className="text-gray-500 mr-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                        />
                                        Original Total (Including Base Rate):
                                      </span>
                                      <span className="text-sm sm:text-base text-gray-800">
                                        <strong>{(total + effectiveBaseRate).toFixed(2)} {CURRENCY_CODE}</strong>
                                      </span>
                                    </div>
                                  )}
                                  <div className="flex items-center justify-between mt-2 text-green-600">
                                    <span className="text-xs sm:text-sm flex items-center">
                                      <FontAwesomeIcon
                                        icon={faPaw}
                                        className="text-green-500 mr-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                      />
                                      Discount Applied{discount?.code ? ` (${discount.code})` : ""}:
                                    </span>
                                    <strong className="text-sm sm:text-base">
                                      -{discountAmount.toFixed(2)} {CURRENCY_CODE}
                                    </strong>
                                  </div>
                                </>
                              )}

                              {/* Total After Discount */}
                              <div className="flex items-center justify-between mt-4 border-t pt-3">
                                <span className="text-sm sm:text-base text-gray-600 flex items-center">
                                  <FontAwesomeIcon
                                    icon={faPaw}
                                    className="text-green-600 mr-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                  />
                                  Total {discountAmount > 0 ? "(After Discount)" : ""}:
                                </span>
                                <div className="inline-flex items-center">
                                  {applyFreeTaxi ? (
                                    <span className="text-sm sm:text-base text-gray-800 mr-1">
                                      <strong>{(total - discountAmount).toFixed(2)} {CURRENCY_CODE}</strong>
                                    </span>
                                  ) : (
                                    <span className="text-sm sm:text-base text-gray-800">
                                      <strong>{(total + effectiveBaseRate - discountAmount).toFixed(2)} {CURRENCY_CODE}</strong>
                                    </span>
                                  )}
                                </div>
                              </div>

                              {/* VAT Section */}
                              <div className="flex items-center justify-between pt-3">
                                <span className="text-sm sm:text-base text-gray-600 flex items-center">
                                  <FontAwesomeIcon
                                    icon={faPaw}
                                    className="text-green-600 mr-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                  />
                                  VAT (5%):
                                </span>
                                <div className="inline-flex items-center">
                                  <span className="text-sm sm:text-base text-gray-800">
                                    <strong>+{vatAmount.toFixed(2)} {CURRENCY_CODE}</strong>
                                  </span>
                                </div>
                              </div>

                              {/* Grand Total */}
                              <div className="flex items-center justify-between mt-4 border-t pt-3">
                                <span className="text-sm sm:text-lg text-purple-600 flex items-center">
                                  <FontAwesomeIcon
                                    icon={faPaw}
                                    className="mr-2 w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0"
                                  />
                                  Grand Total (After VAT):
                                </span>
                                <span className="text-sm sm:text-lg text-gray-800">
                                  <strong>{finalTotal.toFixed(2)} {CURRENCY_CODE}</strong>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="mb-6 bg-white p-6 rounded-2xl shadow-md border-l-4 border-primary">
                            <div className="space-y-4">

                              {/* Acceptance Checkbox */}
                              <div className="flex items-start space-x-3">
                                <div className="flex items-center h-5">
                                  <input
                                    id="terms"
                                    name="terms"
                                    type="checkbox"
                                    required
                                    checked={state.termsAccepted}
                                    onChange={(e) =>
                                      dispatch({
                                        type: "UPDATE_FIELD",
                                        field: "termsAccepted",
                                        payload: e.target.checked
                                      })
                                    }
                                    className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary cursor-pointer"
                                  />
                                </div>
                                <div className="min-w-0 flex-1">
                                  <label htmlFor="terms" className="text-sm text-gray-600 cursor-pointer">
                                    I have read and agree to the{" "}
                                    <a
                                      href={routes.terms}
                                      className="text-primary hover:text-accent underline font-medium"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Terms of Service
                                    </a>
                                    {" "}and{" "}
                                    <a
                                      href={routes.privacy_policy}
                                      className="text-primary hover:text-accent underline font-medium"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      Privacy Policy
                                    </a>
                                  </label>
                                </div>
                              </div>

                            </div>
                          </div>
                        </>
                      )}

                      {step === 7 && (
                        <DeliveryPaymentMethodSelection delivery={deliveryData} onCancel={onCancel} asDiv={true} onSave={onSave} />
                      )}

                    </div>
                  )}

                  {/* Navigation buttons */}
                  <div className="my-8 flex justify-between">
                    {step > 2 && (
                      <>
                        {step !== 7 && (
                          <button
                            type="button"
                            onClick={handlePrevStep}
                            className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg"
                          >
                            Back
                          </button>
                        )}

                        {step === 6 && (
                          <motion.button
                            type="submit"
                            whileHover={loading ? {} : { scale: 1.05 }}  // Disable hover effect when loading
                            whileTap={loading ? {} : { scale: 0.95 }}    // Disable tap effect when loading
                            disabled={loading}                           // Disable button when submitting
                            className={`font-semibold px-6 py-3 rounded-lg shadow-md transition-all duration-300 ease-in-out 
                                                       ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-gradient-to-r from-purple-500 to-indigo-600 text-white"}`}
                          >
                            {loading ? (
                              <div className="flex items-center">
                                <svg
                                  className="animate-spin h-5 w-5 mr-2 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0116 0H4z"></path>
                                </svg>
                                Processing...
                              </div>
                            ) : (
                              "Confirm & Submit 🚀"
                            )}
                          </motion.button>
                        )}
                      </>
                    )}
                    {step < 6 && step > 2 && (
                      <button
                        type="button"
                        onClick={handleNextStep}
                        className="bg-primary text-white px-4 py-2 rounded-lg"
                      >
                        {step === 2 ? "Confirm Dropoff" : "Next"}
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};


export default DeliveryRequest;
